/*
 * @Author: your name
 * @Date: 2020-08-14 10:27:59
 * @LastEditTime: 2020-08-18 08:43:01
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /lisa/digitalnewspaperofinternet/src/router/index.js
 */
import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

const routes = [{
    path: '*',
    redirect: "/"
}, {
    path: '/',
    name: 'homePage',
    component: () => import('../views/homePage/homePage.vue'),
},{
    path: '/county', //区县报纸
    name: 'county',
    component: () => import('../views/countyNewspaper/countyNewspaper.vue'),
}, {
    path: '/newspaper',
    name: 'newspaperContent',
    component: () => import('../views/newspaperContent/newspaperContent.vue')
}, {
    path: '/detail',
    name: 'newspapersDetail',
    component: () => import('../views/newspaperContent/newspaperOfMobileAndPad/readNewspapersDetail.vue')
}, {
    path: '/search',
    name: 'search',
    component: () => import('../views/search/search.vue')
}]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

export default router